import {
  backgroundColorCss,
  boxShadowCss,
  mobileBackgroundColorCss,
  mobileBoxShadowCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { BackgroundColorEntityInterface } from 'src/shared/schemas/background-color.schema'
import { BorderRadiusEntityInterface } from 'src/shared/schemas/border.schema'
import { BoxShadowEntityInterface } from 'src/shared/schemas/box-shadow.schema'
import { PaddingEntityInterface } from 'src/shared/schemas/padding.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import styled, { css } from 'styled-components'

type FaqItemUiProps = StrictRequired<
  BackgroundColorEntityInterface &
    BorderRadiusEntityInterface &
    PaddingEntityInterface &
    BoxShadowEntityInterface
>

const FaqItemUi = styled.div<FaqItemUiProps>`
  border-radius: ${p => p.borderRadius}px;
  ${backgroundColorCss}
  ${paddingsCss}
  ${boxShadowCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
    ${mobileBoxShadowCss}
    ${mobileBackgroundColorCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
      ${mobileBoxShadowCss}
      ${mobileBackgroundColorCss}
    `}
`

export default FaqItemUi
